import classNames from 'classnames';
import InfoIcon from 'components/Icons/info.svg';
import { FunctionComponent, ReactNode } from 'react';
import { Variants } from 'types/bosphorus.type';

interface BAlertProps {
  variant?: Variants;
  children: ReactNode;
  className?: string;
  hideIcon?: boolean;
}

const BAlert: FunctionComponent<BAlertProps> = ({
  variant = 'primary',
  children,
  className,
  hideIcon = false,
}) => {
  const classesByVariant: Record<Variants, string> = {
    primary: 'text-primary-700 bg-primary-100 border-primary-700',
    secondary: 'text-slate-700 bg-slate-100 border-slate-700',
    success: 'text-success-800 bg-success-100 border-success-800',
    danger: 'text-danger-700 bg-danger-100 border-danger-700',
    warning: 'text-warning-700 bg-warning-100 border-warning-700',
    info: 'text-info-700 bg-info-100 border-info-700',
  };

  return (
    <span
      className={classNames(
        'flex w-full items-center gap-2 rounded-md border px-4 py-2',
        className,
        classesByVariant[variant]
      )}
    >
      {hideIcon ? null : <InfoIcon className="w-6 flex-shrink-0" />}
      <div>{children}</div>
    </span>
  );
};

export default BAlert;
